export class RemovalViewModel {

  constructor(
    readonly date: Date,
    readonly pen: string,
    readonly numberOfAnimals: number,
    readonly weight: number,
    readonly code: string, //enum
    readonly reason: string, //enum
    ) { }
}